module.exports = __webpack_public_path__ + "media/images/country_flags/bz-6b0b0cd9e6405051a09620a0d9328de2.png";